import QueryBase from './QueryBase';
import log from 'loglevel';
/**
 *
 * Created Date: 2019-04-25, 16:41:23 (zhenliang.sun)
 * Last Modified: 2019-08-09, 18:08:31 (zhenliang.sun)
 * Email: zhenliang.sun@gmail.com
 *
 * Distributed under the MIT license. See LICENSE file for details.
 * Copyright (c) 2019 vhall
 */

/**
 * Seek 查询策略
 *
 * @export
 * @class QuerySeek
 * @extends {QueryBase}
 * @author zhenliang.sun
 */
export default class QuerySeek extends QueryBase {
  constructor() {
    super();
  }

  async query(start, end) {
    log.info(`从开始时间${start}到结束时间${end}检索信息`);
    // 先找到时间段内，最后一页
    let flipResult = await this.dbController.select([
      { key: 'flipOver', value: 1, compare: '=' },
      { key: 'time', value: end, compare: '<=', optional: true },
      { key: 'uid', value: 0, compare: '>=' }
    ]);

    // 先找到 小于该时间的翻页，并且取数组的最后一项
    // let flipResult = await this.dbController.select([
    //   { key: 'flipOver', value: 1, compare: '=' },
    //   { key: 'time', value: start, compare: '<', optional: true },
    //   { key: 'uid', value: 0, compare: '>=' }
    // ]);

    if (flipResult.length === 0) {
      log.warn(`no such flipOver data, time:${start}`);
      return [];
    }

    log.info(`一共找到了${flipResult.length}条翻页消息`);
    // 拿到最后一条翻页的文档hash 和 currentPage
    let flipData = flipResult.pop();
    let fileHash = flipData.hash;
    let fileCurrentPage = flipData.currentPage;
    let flipTime = flipData.time;
    log.info(
      `基于${start}找到该文档最后一条翻页消息，文档hash:${fileHash} , page:${fileCurrentPage}, time:${flipTime}`
    );

    log.info(
      `现在要找到数据时间介于${flipTime}--${end}, 文档hash:${fileHash}, 页码：${fileCurrentPage}, cid:${flipData.cid}, flipOver:0, uid>0`
    );
    // 从翻页时间到目标时间
    let afterFlipResult = await this.dbController.select([
      { key: 'time', value: flipTime, compare: '>=', optional: true },
      { key: 'time', value: end, compare: '<=' },
      { key: 'hash', value: fileHash, compare: '=' },
      { key: 'currentPage', value: fileCurrentPage, compare: '=' },
      { key: 'cid', value: flipData.cid, compare: '=' },
      { key: 'flipOver', value: 0, compare: '=' },
      { key: 'uid', value: 0, compare: '>=' }
    ]);
    // 把翻页添加进去
    afterFlipResult.unshift(flipData);
    log.info(
      `基于time: ${flipTime}-${end}, 共查询出${afterFlipResult.length}条数据，翻页距离结束共有${end - flipTime}s.`
    );
    // log.info(`这${afterFlipResult.length}条数据分别是`)
    // for(let item of afterFlipResult) {
    //   log.info(JSON.stringify(item) + '\n')
    // }

    return afterFlipResult || [];
  }
}
